import { render, staticRenderFns } from "./SalesSpeedChart.vue?vue&type=template&id=c85956e6&scoped=true&"
import script from "./SalesSpeedChart.vue?vue&type=script&lang=js&"
export * from "./SalesSpeedChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesSpeedChart.vue?vue&type=style&index=0&id=c85956e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85956e6",
  null
  
)

export default component.exports